export const dispatchInAppEvent = (event, details) => {
    document.dispatchEvent(new CustomEvent(event, { detail: details }));
};
